<div class="container">
  <div class="content" [class.increased-height]="increaseHeight">
    <div  class="side-container">
      <div class="user-image">
        @if (profileData) {
          <figure>
            <img [src]="avatarImageDataUrl ? avatarImageDataUrl : profileData?.User.AvatarURL" alt="profileData"
              class="profile-image">
              <figcaption>
                <label for="upload-photo" class="upload-label">
                  <img src="assets/icons/edit.svg" alt="icon" class="image-icon"  #edit [isTitle] = "true" fiTranslation="ALT_TEXT_REQUEST_LIST_EDIT" matTooltip="{{edit.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style' >
                  <span class="text" fiTranslation="USER_PROFILE_EDIT_CHANGE_IMAGE"></span>
                </label>
                <input type="file" accept="image/*" name="profile-image" id="upload-photo" (change)="onImageUpload($event)">
              </figcaption>
            </figure>
          }
        </div>

        <div class="user-info">
          @if (profileData?.User?.FirstName) {
            <h2 class="user-name">{{ profileData?.User?.FirstName + ' ' + profileData?.User?.LastName }}</h2>
          }

          <h4 class="user-profession">{{ profileData?.User.Organisation }}</h4>

          <div class="user-mail contact-field">
            <a [href]="'mailto: ' + profileData?.User.Email" class="contact-field-link">
              <img src="assets/icons/mail-small.svg" alt="mail" class="icon" #mail [isTitle] = "true" fiTranslation="ALT_TEXT_CONTACT_DETAIL_EMAIL" matTooltip="{{mail.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
              <span class="text">{{ profileData?.User.Email }}</span>
            </a>
          </div>

          @if (profileData?.User.Phone) {
            <div class="user-telephone-1 contact-field">
              <a [href]="'tel: ' + profileData?.User.Phone" class="contact-field-link">
                <img src="assets/icons/telephone.svg" alt="tel" class="icon" #telephone [isTitle] = "true" fiTranslation="ALT_TEXT_CONTACT_DETAIL_PHONE" matTooltip="{{telephone.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
                <span class="text">{{ profileData?.User.Phone }}</span>
              </a>
            </div>
          }

          @if (profileData?.User.Mobile) {
            <div class="user-telephone-2 contact-field">
              <a [href]="'tel: ' + profileData?.User.Mobile" class="contact-field-link">
                <img src="assets/icons/phone.svg" alt="phone" class="icon" #mobile [isTitle] = "true" fiTranslation="ALT_TEXT_CONTACT_DETAIL_MOBIL" matTooltip="{{mobile.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
                <span class="text">{{ profileData?.User.Mobile }}</span>
              </a>
            </div>
          }
        </div>

        <div class="user-notification">
          <p class="label" fiTranslation="USER_PROFILE_EDIT_HEADLINE_NOTIFICATIONS"></p>

          <div class="notification-option"
            [class.selected]="userForm.controls.NotificationsEnabled.value"
            (click)="userForm.controls.NotificationsEnabled.setValue(true)">
            <div class="circle"></div>
            <span class="text" fiTranslation="USER_PROFILE_EDIT_NOTIFICATIONS_AVAILABLE"></span>
          </div>
          <div class="notification-option"
            [class.selected]="!userForm.controls.NotificationsEnabled.value"
            (click)="userForm.controls.NotificationsEnabled.setValue(false)">
            <div class="circle"></div>
            <span class="text" fiTranslation="USER_PROFILE_EDIT_GENERAL_NOT_AVAILABLE"></span>
          </div>
        </div>

        <div class="user-push">
          <p class="label" fiTranslation="USER_PROFILE_EDIT_HEADLINE_PUSH"></p>

          <div class="push-option"
            [class.selected]="userForm.controls.LeadMailEnabled.value"
            (click)="userForm.controls.LeadMailEnabled.setValue(true)">
            <div class="circle"></div>
            <span class="text" fiTranslation="USER_PROFILE_EDIT_PUSH_AVAILABLE"></span>
          </div>
          <div class="push-option"
            [class.selected]="!userForm.controls.LeadMailEnabled.value"
            (click)="userForm.controls.LeadMailEnabled.setValue(false)">
            <div class="circle"></div>
            <span class="text" fiTranslation="USER_PROFILE_EDIT_GENERAL_NOT_AVAILABLE"></span>
          </div>
        </div>

        <div class="user-appointment">
          <p class="label" fiTranslation="USER_PROFILE_EDIT_HEADLINE_APPOINTMENT_NOTIFICATION"></p>

          <div class="appointment-option"
            [class.selected]="userForm.controls.AppointmentMailEnabled.value"
            (click)="userForm.controls.AppointmentMailEnabled.setValue(true)">
            <div class="circle"></div>
            <span class="text" fiTranslation="USER_PROFILE_EDIT_APPOINTMENT_AVAILABLE"></span>
          </div>
          <div class="appointment-option"
            [class.selected]="!userForm.controls.AppointmentMailEnabled.value"
            (click)="userForm.controls.AppointmentMailEnabled.setValue(false)">
            <div class="circle"></div>
            <span class="text" fiTranslation="USER_PROFILE_EDIT_GENERAL_NOT_AVAILABLE"></span>
          </div>
        </div>

        <div class="user-reminder-mail">
          <p class="label" fiTranslation="USER_PROFILE_EDIT_HEADLINE_NOTIFICATION_LEAD_REMINDER"></p>

          <div class="reminder-option"
            [class.selected]="userForm.controls.ReminderMailEnabled.value"
            (click)="userForm.controls.ReminderMailEnabled.setValue(true)">
            <div class="circle"></div>
            <span class="text" fiTranslation="USER_PROFILE_EDIT_NOTIFICATION_LEAD_REMINDER_ENABLE"></span>
          </div>
          <div class="reminder-option"
            [class.selected]="!userForm.controls.ReminderMailEnabled.value"
            (click)="userForm.controls.ReminderMailEnabled.setValue(false)">
            <div class="circle"></div>
            <span class="text" fiTranslation="USER_PROFILE_EDIT_NOTIFICATION_LEAD_REMINDER_DISABLE"></span>
          </div>
        </div>

        @if (!isDealerPartner && profileData) {
          <div class="user-gvm-mail">
            <p class="label" fiTranslation="USER_PROFILE_EDIT_HEADLINE_NOTIFICATION_WEEKLY_RECAP_GVL"></p>
            <div class="gvm-option"
              [class.selected]="userForm.controls.GvlMailEnabled.value"
              (click)="userForm.controls.GvlMailEnabled.setValue(true)">
              <div class="circle"></div>
              <span class="text" fiTranslation="USER_PROFILE_EDIT_NOTIFICATION_WEEKLY_RECAP_GVL_ENABLE"></span>
            </div>
            <div class="gvm-option"
              [class.selected]="!userForm.controls.GvlMailEnabled.value"
              (click)="userForm.controls.GvlMailEnabled.setValue(false)">
              <div class="circle"></div>
              <span class="text" fiTranslation="USER_PROFILE_EDIT_NOTIFICATION_WEEKLY_RECAP_GVL_DISABLE"></span>
            </div>
          </div>
          <div class="complete-mail">
            <p class="label" fiTranslation="USER_PROFILE_EDIT_HEADLINE_NOTIFICATION_CLOSE_REQUESTS"></p>
            <div class="copy-option"
              [class.selected]="userForm.controls.CompletedMailEnabled.value"
              (click)="userForm.controls.CompletedMailEnabled.setValue(true)">
              <div class="circle"></div>
              <span class="text" fiTranslation="USER_PROFILE_EDIT_APPOINTMENT_AVAILABLE"></span>
            </div>
            <div class="copy-option"
              [class.selected]="!userForm.controls.CompletedMailEnabled.value"
              (click)="userForm.controls.CompletedMailEnabled.setValue(false)">
              <div class="circle"></div>
              <span class="text" fiTranslation="USER_PROFILE_EDIT_GENERAL_NOT_AVAILABLE"></span>
            </div>
          </div>
          <div class="copy-external-emails">
            <p class="label" fiTranslation="USER_PROFILE_EDIT_HEADLINE_NOTIFICATION_EXTERNALLY_ASSIGNED"></p>
            <div class="copy-option"
              [class.selected]="userForm.controls.ExternalMailCCEnabled.value"
              (click)="userForm.controls.ExternalMailCCEnabled.setValue(true)">
              <div class="circle"></div>
              <span class="text" fiTranslation="USER_PROFILE_EDIT_HEADLINE_NOTIFICATION_EXTERNALLY_ASSIGNED_RECIEVE_COPY"></span>
            </div>
            <div class="copy-option"
              [class.selected]="!userForm.controls.ExternalMailCCEnabled.value"
              (click)="userForm.controls.ExternalMailCCEnabled.setValue(false)">
              <div class="circle"></div>
              <span class="text" fiTranslation="USER_PROFILE_EDIT_HEADLINE_NOTIFICATION_EXTERNALLY_ASSIGNED_DONT_RECIEVE_COPY"></span>
            </div>
          </div>
        }
        @if (false) {
          <div class="user-password">
            <p class="label" fiTranslation="USER_PROFILE_EDIT_HEADLINE_PASSWORD"></p>
            <div class="password-option">
              <a [href]="passwordChangeURL">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" #keyword [isTitle] = "true" fiTranslation="ALT_TEXT_USER_PROFIL_CHANGE_PASSWORD" matTooltip="{{keyword.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
                  <g id="key" transform="translate(-2.25 -2.247)" opacity="0.7">
                    <path id="Path_733" data-name="Path 733"
                      d="M14.837,2.359a5.525,5.525,0,0,1,4.3,6.542,5.571,5.571,0,0,1-5.4,4.369,5.442,5.442,0,0,1-1.572-.23l-.973,1.139-.461.213H9.546v1.821l-.608.607H7.114V18.64l-.608.607H2.858L2.25,18.64v-2.8l.177-.428L8.476,9.373a5.409,5.409,0,0,1-.243-1.705,5.5,5.5,0,0,1,6.6-5.31Zm1.6,8.739a4.329,4.329,0,0,0,1.507-2.433l0,.006a4.3,4.3,0,0,0-5.1-5.111,4.342,4.342,0,0,0-3.4,4.127A4.1,4.1,0,0,0,9.74,9.3l-.133.659-6.14,6.13v1.942H5.9V16.212l.608-.607H8.33V13.784l.608-.607h1.514l1.065-1.233.682-.17a4.227,4.227,0,0,0,1.543.289,4.344,4.344,0,0,0,2.7-.965ZM15.421,7.782a1.215,1.215,0,1,0-1.66.3A1.212,1.212,0,0,0,15.421,7.782Z"
                      fill-rule="evenodd" class="fi-fill-primary-default"/>
                    </g>
                  </svg>
                  <span class="text" fiTranslation="USER_PROFILE_EDIT_PASSWORD_OPTION"></span>
                </a>
              </div>
            </div>
          }
        </div>
        <div class="main-content">
          <h2 class="title" fiTranslation="USER_PROFILE_EDIT"></h2>
          <span class="field-name fixed" fiTranslation="FORM_ERRORMSG_HEADLINE_MANDATORY_FIELDS"></span>

          <form (submit)="onFormSubmit()" [formGroup]="userForm" class="user-form">
            @if (false) {
              <div class="form-field name">
                @if (showMaxlengthError) {
                  <div class="alert-danger-cont">
                    <span class="close-icon" (click)="showMaxlengthError = false"></span>
                    <span fiTranslation="GENERAL_ERROR_FIELD_TO_LONG"></span>
                  </div>
                }
                <label class="input-label">
                  <span class="field-name" fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_VORNAME"></span><span
                class="field-name">*</span>
                <input type="text" maxlength="500" readonly class="input-field" [isPLaceHolder]="true" fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_VORNAME" formControlName="FirstName"
                  [class.empty-field]="invalidFormControl('FirstName') || invalidMaxLength('FirstName')" >
                </label>
                @if (invalidFormControl('FirstName')) {
                  <div class="error-field">
                    @if (userForm.controls.FirstName.errors.required) {
                      <p class="error" fiTranslation="FORM_COMPLETE_MANDATORY_FIELDS"></p>
                    }
                  </div>
                }
              </div>
            }

            @if (false) {
              <div class="form-field name">
                @if (showMaxlengthError) {
                  <div class="alert-danger-cont">
                    <span class="close-icon" (click)="showMaxlengthError = false"></span>
                    <span fiTranslation="GENERAL_ERROR_FIELD_TO_LONG"></span>
                  </div>
                }
                <label class="input-label">
                  <span class="field-name" fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_NACHNAME"></span><span
                class="field-name">*</span>
                <input type="text" maxlength="500" readonly class="input-field" [isPLaceHolder]="true" fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_NACHNAME" formControlName="LastName"
                  [class.empty-field]="invalidFormControl('LastName') || invalidMaxLength('LastName')" >
                </label>
                @if (invalidFormControl('LastName')) {
                  <div class="error-field">
                    @if (userForm.controls.LastName.errors.required) {
                      <p class="error" fiTranslation="FORM_COMPLETE_MANDATORY_FIELDS"></p>
                    }
                  </div>
                }
              </div>
            }

            @if (false) {
              <div class="form-field">
                <label class="input-label">
                  <span class="field-name" fiTranslation="FORM_HEADLINE_E-MAIL"></span><span class="field-name">*</span>
                  <input type="email" maxlength="500" readonly class="input-field" [isPLaceHolder]="true" fiTranslation="FORM_HEADLINE_E-MAIL" formControlName="Email"
                    [class.empty-field]="invalidFormControl('Email')">
                  </label>
                  @if (invalidFormControl('Email')) {
                    <div class="error-field">
                      @if (userForm.controls.Email.errors.email) {
                        <p class="error" fiTranslation="CONTACT_ERRORMSG_EMAIL_NOT_VALID"></p>
                      }
                      @if (userForm.controls.Email.errors.required) {
                        <p class="error" fiTranslation="FORM_COMPLETE_MANDATORY_FIELDS"></p>
                      }
                    </div>
                  }
                </div>
              }

              @if (false) {
                <div class="form-field select-form-fields">
                  <span class="field-name" fiTranslation="USER_PROFILE_EDIT_HEADLINE_TELEPHONE"></span>
                  <div class="select-form phone">
                    <div fiCustomSelect
                      [readonly]="true"
                      (value)="userForm?.controls.PhoneCountryCode.setValue($event)"
                      [displaySelectionValue]="userForm?.controls.PhoneCountryCode.value"
                      [data]="numberPrefixes"
                      [dataValueKey]="'code'"
                      [dataNameKey]="'name'"
                      [class.invalid]="invalidFormControl('PhoneCountryCode')"
                      class="select-field custom-select">
                      <span class="selected-value placeholder"></span>
                      <input class="search" maxlength="500">
                      <img src="assets/icons/arrow-down-dark.svg" alt="icon" class="arrow">
                      <div class="options-cont">
                        <ul class="options"></ul>
                      </div>
                    </div>
                    <label class="input-label">
                      <input type="tel" maxlength="500" readonly class="input-field" [isPLaceHolder]="true" fiTranslation="USER_PROFILE_EDIT_HEADLINE_TELEPHONE" formControlName="Phone"
                        [class.empty-field]="invalidFormControl('Phone') || invalidMaxLength('Phone')">
                      </label>
                    </div>
                  </div>
                }

                @if (false) {
                  <div class="form-field select-form-fields">
                    <span class="field-name" fiTranslation="FORM_HEADLINE_MOBILE"></span>
                    <div class="select-form phone">
                      <div fiCustomSelect
                        [readonly]="true"
                        (value)="userForm?.controls.MobileCountryCode.setValue($event)"
                        [displaySelectionValue]="userForm?.controls.MobileCountryCode.value"
                        [data]="numberPrefixes"
                        [dataValueKey]="'code'"
                        [dataNameKey]="'name'"
                        [class.invalid]="invalidFormControl('MobileCountryCode')"
                        class="select-field custom-select">
                        <span class="selected-value placeholder"></span>
                        <input class="search" maxlength="500">
                        <img src="assets/icons/arrow-down-dark.svg" alt="icon" class="arrow">
                        <div class="options-cont">
                          <ul class="options"></ul>
                        </div>
                      </div>
                      <label class="input-label">
                        <input type="tel" maxlength="500" readonly class="input-field" [isPLaceHolder]="true" fiTranslation="USER_PROFILE_EDIT_HEADLINE_TELEPHONE" formControlName="Mobile"
                          [class.empty-field]="invalidFormControl('Mobile')">
                        </label>
                      </div>
                    </div>
                  }

                  <div class="form-field select-form-fields">
                    <div class="select-form language-form">
                      <p class="form-label"><span fiTranslation="FORM_HEADLINE_LANGUAGE"></span>*</p>
                      <div fiCustomSelect
                        [class.empty-field]="invalidFormControl('LanguageCode')"
                        (value)="userForm.controls.LanguageCode.setValue($event); actionHelper.notifyAboutEdit();"
                        [displaySelectionValue]="userForm.controls.LanguageCode.value"
                        [data]="resourceLanguages"
                        [dataValueKey]="'IsoCode'"
                        [dataNameKey]="'Name'"
                        class="select-field custom-select">
                        <span class="selected-value placeholder"></span>
                        <input class="search" maxlength="500">
                        <img src="assets/icons/arrow-down-dark.svg" alt="arrow" class="arrow">

                        <div class="options-cont">
                          <ul class="options"></ul>
                        </div>
                      </div>
                      @if (invalidFormControl('LanguageCode')) {
                        <div class="error-field">
                          @if (userForm.controls.LanguageCode.errors.required) {
                            <p class="error" fiTranslation="FORM_COMPLETE_MANDATORY_FIELDS"></p>
                          }
                        </div>
                      }
                    </div>
                  </div>

                  <div class="form-field select-form-fields">

                    <div class="select-form status-form">
                      <div class="status-form-checkbox" (click)="toggleDateForm(); actionHelper.notifyAboutEdit();">
                        @if (!dateFormIsHidden) {
                          <div class="checked">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.275" height="13.094" viewBox="0 0 15.275 13.094">
                              <path id="Path_732" data-name="Path 732"
                                d="M313.754,334.265l-3.066-3.446-1.888,2.122,4.016,4.515a1.236,1.236,0,0,0,1.888,0l4.738-5.326,4.633-5.208-1.888-2.122Z"
                                transform="translate(-308.8 -324.8)" class="fi-fill-brand-primary-default"/>
                              </svg>
                            </div>
                          }
                        </div>
                        <div class="checked-status-form-checkbox-text" (click)="toggleDateForm()">
                          <span fiTranslation="USER_PROFILE_EDIT_ABSENT"></span>
                        </div>
                      </div>

                      <div class="absence-cont">
                        @if (!dateFormIsHidden) {
                          <div class="select-form date-form">
                            <p class="form-label" fiTranslation="USER_PROFILE_EDIT_HEADLINE_ABSENCE_DATE"></p>
                            @if (!dateFormIsHidden) {
                              <fi-date-time
                                [withHours]="false"
                                (dateRangeSelected)="setAbsenceDates($event); actionHelper.notifyAboutEdit();"
                                (recurringData) =  "setRecurringData($event); actionHelper.notifyAboutEdit();"
                                [dateRangeToDisplay]="[absenceForm.controls.From.value, absenceForm.controls.To.value]"
                [absenceRecurring]="{
                  RecurringTimeFrom: absenceForm.controls.RecurringTimeFrom.value,
                  RecurringTimeTo: absenceForm.controls.RecurringTimeTo.value,
                  RecurringDays: absenceForm.controls.RecurringDays.value
                }"
                                [class.date-error]="noDateIsChecked"
                                [profileSpace] = "profileSpace"
                                selectMode="range">
                              </fi-date-time>
                            }
                          </div>
                        }

                        @if (!dateFormIsHidden) {
                          <fi-forward-user
                            [userId]="absenceForm.controls.SubstituteUserId.value"
                            (menuOpened)="increaseHeight = $event"
                            (userIdSelected)="absenceForm.controls.SubstituteUserId.setValue($event); actionHelper.notifyAboutEdit();"
                            >
                          </fi-forward-user>
                        }
                      </div>
                    </div>

                    <button type="submit" class="submit-btn">
                      <img src="assets/icons/save-blue.svg" alt="save" class="icon" #save [isTitle] = "true" fiTranslation="ALT_TEXT_REQUEST_LIST_SAFE" matTooltip="{{save.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
                      <span class="text" fiTranslation="BUTTON_PROFILE_SAFE"></span>
                    </button>

                    <div class="calendar-spacer" #profileSpace></div>


                  </form>
                </div>
              </div>
            </div>
